module.exports = __webpack_public_path__ + "static/media/Col3ablur.aae3e202.png";


//////////////////
// WEBPACK FOOTER
// ./src/Col3ablur.png
// module id = 3
// module chunks = 0